import {HubApiRequest} from '../hub-api-request';
import {HubMethod} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';
import {
    RegistrationResponse,
    RegistrationWithConfirmationReq
} from '../protocol/registration-req';

export class RegistrationWithConfirmation extends HubApiRequest<RegistrationWithConfirmationReq, RegistrationResponse> {
    constructor(url: string, deviceIdentifier: string, data: RegistrationWithConfirmationReq) {
        super(url, HubMethod.REGISTRATION_WITH_CONFIRMATION, deviceIdentifier, data, uuidv4());
    }
}
